<template>
  <section>
    <div class="columns is-centered">
      <div class="column is-6">
        <div class="section">
          <div class="container">
            <b-loading
              :is-full-page="true"
              :active.sync="isLoading"
              :can-cancel="false"
            ></b-loading>
            <update-password-form @formSubmit="submitUpdatePassword" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Auth } from 'aws-amplify'

import UpdatePasswordForm from '@/components/common/settings/UpdatePasswordForm'

export default {
  components: { UpdatePasswordForm },
  name: 'OnBoardProfile',
  mixins: [],
  props: {},
  data() {
    return {
      isLoading: false
    }
  },
  computed: {},
  methods: {
    submitUpdatePassword(formData) {
      let self = this
      self.isLoading = true
      Auth.currentAuthenticatedUser()
        .then(user => {
          return Auth.changePassword(
            user,
            formData.oldPassword,
            formData.newPassword
          )
        })
        .then(() =>
          self.$toast.open({
            message: self.$t('Contraseña actualizada'),
            type: 'success',
            duration: 5000
          })
        )
        .catch(err =>
          self.$toast.open({
            message: err.message,
            type: 'error',
            duration: 5000
          })
        )
        .then(() => (self.isLoading = false))
    }
  },
  mounted() {}
}
</script>
